"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.regexp.split");require("core-js/modules/es6.function.name");

































































var _formatter = require("@/utils/formatter"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { searchData: { code: '', status: '', pageIndex: 1, pageSize: 10 }, //过滤表单
      pageData: { page: 1, rows: 10, total: 0, pages: 1 }, //分页数据
      statusList: [{ id: '0', name: '下架' }, { id: '1', name: '上架' }], //状态列表
      showAdd: false, //是否显示新增配置弹窗
      tableColumn: [{ prop: 'code', label: '设备型号' }, { prop: 'status', label: '状态', formatter: _formatter.recommendStatusFormatter }, { prop: 'updateTime', label: '配置时间' }, { prop: 'remark', label: '备注' }], //表头数据
      tableData: [], //配置列表
      modelList: [], //产品型号列表
      configForm: { code: '', name: '', status: '1', remark: '' }, //新增配置表单
      configFormRule: { code: [{ required: true, message: '请选择设备型号', trigger: 'change' }] }, //新增配置表单rule
      configEdit: false, //是否编辑配置
      currentConfig: '' //当前配置项
    };}, mounted: function mounted() {this.fetchConfigList();this.fetchModelList();}, computed: { modelValue: function modelValue() {return this.configForm.code + '/' + this.configForm.name;} },
  methods: {
    /**
              * 获取配置列表
              */
    fetchConfigList: function fetchConfigList() {var _this = this;
      var params = {
        pageIndex: this.searchData.pageIndex,
        pageSize: this.searchData.pageSize };

      params.code = this.searchData.code || null;
      params.status = this.searchData.status || null;
      this.postData('/api/todayRecommend/devices', params, function (res) {
        _this.tableData = res.devices;
        _this.pageData.page = res.pageNum;
        _this.pageData.total = res.total;
      });
    },

    /**
        * 获取产品型号列表
        */
    fetchModelList: function fetchModelList() {var _this2 = this;
      this.getData('/api/faDeviceType', { page: 1, rows: 99999999 }, function (res) {
        _this2.modelList = res.list;
      });
    },

    /**
        * 查询
        */
    onClickSearch: function onClickSearch() {
      this.$set(this.searchData, 'pageIndex', 1);
      this.fetchConfigList();
    },

    /**
        * 重置
        */
    onClickReset: function onClickReset() {
      this.$set(this.searchData, 'code', '');
      this.$set(this.searchData, 'status', '');
      this.$set(this.searchData, 'pageIndex', 1);
      this.fetchConfigList();
    },

    /**
        * 每页Size-change
        */
    handleSizeChange: function handleSizeChange(val) {
      // 分页条数
      this.searchData.pageSize = val;
      this.searchData.pageIndex = 1;
      this.fetchConfigList();
    },

    /**
        * 页码-change
        */
    handleCurrentChange: function handleCurrentChange(val) {
      // 分页页码
      this.searchData.pageIndex = val;
      this.fetchConfigList();
    },

    /**
        * 上架||下架
        */
    offShelfItem: function offShelfItem(row) {var _this3 = this;
      this.$confirm('确定' + (row.status == 1 ? '下架' : '上架') + '该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        _this3.postData('/api/todayRecommend/device/status', { id: row.id, status: row.status == 0 ? 1 : 0 }, function (res) {
          _this3.fetchConfigList();
        });
      }).catch({});
    },

    /**
        * 编辑
        */
    updateItem: function updateItem(row) {
      this.showAdd = true;
      this.configEdit = true;
      this.currentConfig = Object.assign({}, row);
      this.$set(this.configForm, 'code', row.code + '/' + row.name);
      this.$set(this.configForm, 'name', row.name);
      this.$set(this.configForm, 'status', row.status + '');
      this.$set(this.configForm, 'remark', row.remark);
    },

    /**
        * 删除
        */
    delItem: function delItem(row) {var _this4 = this;
      this.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        _this4.delData('/api/todayRecommend/device/' + row.id, {}, function (res) {
          _this4.fetchConfigList();
        });
      }).catch({});
    },

    /**
        * 新增弹窗关闭回调
        */
    onAddDialogClose: function onAddDialogClose() {var _this5 = this;
      this.showAdd = false;
      this.configEdit = false;
      this.$nextTick(function () {
        _this5.$set(_this5.configForm, 'code', '');
        _this5.$set(_this5.configForm, 'name', '');
        _this5.$set(_this5.configForm, 'status', '1');
        _this5.$set(_this5.configForm, 'remark', '');
      });
    },

    /**
        * 设备型号-change
        */
    onCodeChange: function onCodeChange(event) {
      console.log('event=====>', event);
    },

    /**
        * 保存配置
        */
    onSaveConfig: function onSaveConfig() {var _this6 = this;
      this.$refs.configForm.validate(function (valid) {
        if (valid) {
          var params = Object.assign({}, _this6.configForm);
          var codeList = params.code.split('/');
          params.code = codeList[0];
          params.name = codeList[1];
          if (_this6.configEdit) {
            //编辑
            params.id = _this6.currentConfig.id;
          } else {
            //新增
            params.id = 0;
          }
          _this6.postData('/api/todayRecommend/device', params, function (res) {
            _this6.showAdd = false;
            if (!_this6.configEdit) {
              _this6.searchData.pageIndex = 1;
            }
            _this6.fetchConfigList();
          });
        }
      });
    } } };exports.default = _default;